import { isFileNameEndsWith } from 'utils/baseName'
/**
 * Checks whether the file name of a file looks like a trajectory file name.
 */

// function isTrjFileName (fileName: string): boolean
export function isTrjFileName (fileName) {
  return (
    isOutFileName(fileName) ||
    isSmrFileName(fileName) ||
    isPofFileName(fileName) ||
    isPoqFileName(fileName) ||
    isTrajectoryFileName(fileName)
  )
}

export function shouldDisplayTrajectoryImportForm (fileName) {
  return isPofFileName(fileName) ||
    isOutFileName(fileName) ||
    isTrajectoryFileName(fileName)
}

export function allowTrajectoryUploading (fileName) {
  return isPofFileName(fileName) ||
    isOutFileName(fileName) ||
    isTrajectoryFileName(fileName)
}

/**
 * SBET
 */
// function isOutFileName(fileName: string): boolean
export function isOutFileName (fileName) {
  const trjExtensions = ['.out']
  return trjExtensions.some(trjExtension => {
    const lowerCased = fileName.toLowerCase()
    return isFileNameEndsWith(lowerCased, trjExtension) && !isSmrFileName(fileName)
  })
}

/**
 * .SMRMSG is optional
 */
// function isSmrFileName(fileName: string): boolean
export function isSmrFileName (fileName) {
  const lowerCased = fileName.toLowerCase()
  return lowerCased.includes('smrmsg') && isFileNameEndsWith(lowerCased, '.out')
}

/**
 * POF
 */
// isPofFileName(fileName: string): boolean
export function isPofFileName (fileName) {
  const trjExtensions = ['.pof']
  return trjExtensions.some(trjExtension => isFileNameEndsWith(fileName, trjExtension))
}

/**
 * .poq is optional
 */
export function isPoqFileName (fileName) {
  const trjExtensions = ['.poq']
  return trjExtensions.some(trjExtension => isFileNameEndsWith(fileName, trjExtension))
}
export const TrajectoryPathExtensions = [
  '.cls', '.cts',
  '.fls', '.fts',
  '.cl', '.ct',
  '.rls', '.rts',
  '.fl', '.ft',
  '.rl', '.rt',
]
export function isTrajectoryFileName (fileName) {
  return TrajectoryPathExtensions.some(trjExtension => isFileNameEndsWith(fileName, trjExtension))
}

export function isTrjFileType (fileType) {
  return fileType === 'trj'
}

export const TrajectoryFileTypes = [
  '.cls', '.cts',
  '.fls', '.fts',
  '.cl', '.ct',
  '.rls', '.rts',
  '.fl', '.ft',
  '.rl', '.rt',
  '.poq', '.pof',
  '.out', '.smrmsg',
]

/**
 * "Parses" a file and checks if it really is a nav file by looking at the filename.
 * **This function does not really parse any information from the ".nav" file**. It is just named like this
 * in order to stay consistent with the naming for other file formats.
 * @param file The file which should be checked.
 * @return An object containing information about whether the file is a valid nav file, a log about the
 *   parsing and the information read from the header.
 */
// function parseNavFile(file: File): Promise<GenericParserInfo>
export async function parseTrjFile (file) {
  return new Promise(resolve => {
    const log = []
    if (!isTrjFileName(file.name)) {
      log.push({
        level: 'error',
        message: `Unsupported file extension in filename "${file.name}"`,
      })
      resolve({ okay: false, log, fileType: 'trj' })
    }
    if (file.size === 0) {
      log.push({ level: 'error', message: 'Invalid file size. File is empty.' })
      resolve({ okay: false, log, fileType: 'trj' })
      return
    }
    resolve({ okay: true, log, fileType: 'trj' })
  })
}
